// src/store/slices/userProfileSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IssuesProfileSlice {
    selectedView: string;
}

const initialState: IssuesProfileSlice = {
    selectedView: 'info',
};

const issuesProfileSlice = createSlice({
    name: 'issuesProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = issuesProfileSlice.actions;
export default issuesProfileSlice.reducer;